var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"is--intro-mobile visible-xs"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(" Zäune einfach online kaufen ..."),_c('br'),_vm._v(" Vom Original - Seit 2008 ")])])])
}]

export { render, staticRenderFns }